import { CommonErrorCode, ProjectErrorCode } from '~commonInfra/utils/ErrorCodes';

import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { L10n } from '../../commonInfra/L10n/L10n';
import { IProjectBase } from '../models/IProjectInfo';

export namespace ProjectErrors {

  export function errorDetailsFor(projectErrorItem: IErrorItem<IProjectBase>): IErrorDetail {
    return {
      itemName: projectErrorItem.item.name,
      itemUrl:
        projectErrorItem.error.code === CommonErrorCode.ProjectNotFound
          ? null
          : projectUrl(projectErrorItem.item),
      errorMessage: this.errorMessageFor(projectErrorItem)
    };
  }

  export function errorMessageFor(errorItem: IErrorItem<IProjectBase>) {
    const project = errorItem.item;
    switch (errorItem.error.code) {
      case ProjectErrorCode.ProjectChangeOwnerDisabled:
        return Messages.errorProjectChangeOwnerDisabled();
      case ProjectErrorCode.ProjectDescriptionGreaterThanMaxLength:
        return Messages.errorProjectDescriptionTooLong();
      case ProjectErrorCode.ProjectNameAlreadyExists:
        return Messages.errorProjectNameAlreadyExists();
      case CommonErrorCode.ProjectNotFound:
        return Messages.errorProjectNotFound({ PROJECT_NAME: L10n.elideIfLong(project.name) });
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorProjectInsufficientPermissions();
      case ProjectErrorCode.ProjectNameAlreadyExistsInDestinationProject:
          return Messages.errorProjectNameAlreadyExistsAtLocation({ PROJECT_NAME: L10n.elideIfLong(project.name) });

      default:
        return Messages.errorUnknown();
    }
  }

  function projectUrl(project: IProjectBase): string {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls.projectUrl(project.id);
  }
}
